import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { useLocation } from "react-router-dom";
import { base_url } from "../../Global";

const UserProfile = () => {
  const location = useLocation();
  const profileData = location.state?.profile;
  const [mediaData, setMediaData] = useState(null);

  useEffect(() => {
    if (!profileData?._id) return;
    async function getAllMediaByUser(userId) {
      try {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) throw new Error("Access token not found");
        const response = await fetch(base_url + `/entity/user/${userId}`, {
          method: "GET",
          headers: { "Content-Type": "application/json", authorization: accessToken },
        });
        if (!response.ok) throw new Error("Failed to fetch media by user");
        const data = await response.json();
        setMediaData(data);
      } catch (error) {
        console.error("Error fetching media by user:", error);
      }
    }
    getAllMediaByUser(profileData._id);
  }, []);

  if (!profileData) {
    return (
      <div style={{
        flex: 1, minHeight: "100vh", backgroundColor: "#374151",
        color: "white", display: "flex", alignItems: "center",
        justifyContent: "center", fontSize: "18px",
      }}>
        No profile data found.
      </div>
    );
  }

  return (
    <div style={{
      flex: 1,
      minHeight: "100vh",
      backgroundColor: "#374151",
      color: "white",
      padding: "24px 16px",
      boxSizing: "border-box",
      overflowX: "hidden",
    }}>

      {/* ✅ PROFILE CARD */}
      <div style={{
        backgroundColor: "#1f2937",
        borderRadius: "16px",
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        maxWidth: "900px",
        width: "100%",
        boxSizing: "border-box",
      }}>

        {/* ✅ AVATAR + NAME */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          flexWrap: "wrap",
        }}>
          <Avatar
            variant="rounded"
            src={profileData.profileImage}
            alt={profileData.username}
            sx={{ width: 100, height: 100, borderRadius: 3, flexShrink: 0 }}
          />
          <div>
            <h2 style={{
              margin: 0,
              fontSize: "clamp(1.25rem, 4vw, 1.8rem)",
              fontWeight: 700,
              color: "white",
            }}>
              {profileData.username}
            </h2>
            <p style={{ margin: "4px 0 0 0", fontSize: "14px", color: "#9ca3af" }}>
              {profileData.email}
            </p>
          </div>
        </div>

        {/* ✅ FORM FIELDS — side by side desktop, stacked mobile */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "20px",
        }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{ fontSize: "13px", color: "#9ca3af", textTransform: "capitalize", fontWeight: 500 }}>
              Username
            </label>
            <input
              type="text"
              defaultValue={profileData.username}
              style={{
                width: "100%", padding: "12px 16px", borderRadius: "8px",
                border: "none", outline: "none", backgroundColor: "#374151",
                color: "#d1d5db", fontSize: "15px", boxSizing: "border-box", fontFamily: "inherit",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <label style={{ fontSize: "13px", color: "#9ca3af", textTransform: "capitalize", fontWeight: 500 }}>
              Email
            </label>
            <input
              type="text"
              defaultValue={profileData.email}
              style={{
                width: "100%", padding: "12px 16px", borderRadius: "8px",
                border: "none", outline: "none", backgroundColor: "#374151",
                color: "#d1d5db", fontSize: "15px", boxSizing: "border-box", fontFamily: "inherit",
              }}
            />
          </div>
        </div>

        {/* ✅ STATUS BADGES */}
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          {profileData.isBlocked && (
            <span style={{ padding: "6px 14px", borderRadius: "20px", backgroundColor: "#dc2626", color: "white", fontSize: "13px", fontWeight: 600 }}>
              🚫 Blocked
            </span>
          )}
          {profileData.isSubscribed && (
            <span style={{ padding: "6px 14px", borderRadius: "20px", backgroundColor: "#d97706", color: "white", fontSize: "13px", fontWeight: 600 }}>
              ⭐ Prime Member
            </span>
          )}
          {!profileData.isBlocked && !profileData.isSubscribed && (
            <span style={{ padding: "6px 14px", borderRadius: "20px", backgroundColor: "#374151", border: "1px solid #4b5563", color: "#9ca3af", fontSize: "13px" }}>
              Standard User
            </span>
          )}
        </div>
      </div>

      {/* ✅ CONTENT UPLOADED SECTION */}
      {mediaData?.allMedia?.length > 0 && (
        <div style={{ marginTop: "32px", maxWidth: "900px" }}>
          <h3 style={{
            margin: "0 0 16px 0",
            fontSize: "clamp(1.1rem, 3vw, 1.5rem)",
            fontWeight: 600,
            textTransform: "capitalize",
            color: "white",
          }}>
            Content Uploaded
          </h3>

          {/* ✅ Responsive grid — 1 col mobile, 2 tablet, 3 desktop */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
            gap: "16px",
          }}>
            {mediaData.allMedia.map((media, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#1f2937",
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Media preview */}
                <div style={{ position: "relative" }}>
                  {media.entityType === "videos" ? (
                    <video
                      style={{ width: "100%", height: "180px", objectFit: "cover", display: "block" }}
                      loop autoPlay muted
                      src={media.url}
                    />
                  ) : (
                    <img
                      style={{ width: "100%", height: "180px", objectFit: "cover", display: "block" }}
                      src={media.url}
                      alt={media.caption}
                    />
                  )}

                  {/* Checkbox */}
                  <input
                    type="checkbox"
                    style={{
                      position: "absolute", top: "10px", left: "10px",
                      width: "20px", height: "20px", cursor: "pointer",
                    }}
                  />

                  {/* Type badge */}
                  <div style={{
                    position: "absolute", bottom: "8px", left: "8px",
                    backgroundColor: "rgba(55,65,81,0.85)",
                    backdropFilter: "blur(8px)",
                    color: "white", padding: "4px 10px",
                    borderRadius: "6px", fontSize: "12px",
                    textTransform: "capitalize",
                  }}>
                    {media.entityType}
                  </div>
                </div>

                {/* Info */}
                <div style={{ padding: "12px", display: "flex", flexDirection: "column", gap: "4px" }}>
                  <h4 style={{
                    margin: 0, fontSize: "14px", fontWeight: 600,
                    textTransform: "capitalize", color: "white",
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                  }}>
                    {media.tags}
                  </h4>
                  <p style={{
                    margin: 0, fontSize: "13px", color: "#9ca3af",
                    overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                  }}>
                    {media.caption}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;